const RESOURCE_NAME = '/weather';
import restApi from "@/api/rest-api-object";

export default axios => (restApi(axios, RESOURCE_NAME));